"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const Link = _ref => {
  let {
    children,
    isActive,
    onClick
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Gallery-MobileMenuLink', {
    'cds-Gallery-MobileMenuLink--Active': isActive
  });
  return /*#__PURE__*/_react.default.createElement("button", {
    className: rootClassName,
    onClick: onClick
  }, children);
};
exports.Link = Link;
//# sourceMappingURL=Link.js.map